<script setup lang="ts">
import ProductHeader from '../common/product-header.vue';
import PriceBlock from './price-block.vue';
import { MMContainer } from '@mm-frontend/mm-web-ui-kit';

import { computed } from 'vue';
import { useProductPage } from '../../business/use-product-page';
import type { IBadge } from '../../models/badge';

defineProps<{ isShown?: boolean }>();

const { state } = useProductPage();
const currentSku = computed(() => state.currentSku);
const product = computed(() => state.product);
</script>

<template>
  <transition name="slide">
    <div class="floating-cap" v-if="isShown">
      <MMContainer class="floating-cap-wrapper">
        <div class="product-header-wrapper">
          <img class="image" :src="product?.photos[0]?.high || ''" />
          <ProductHeader class="product-header floating" :hasBage="!!currentSku?.discountBadge" />
        </div>

        <PriceBlock
          class="price-block"
          :sellPrice="currentSku?.purchasePrice || 0"
          :fullPrice="currentSku?.fullPrice || 0"
          :badge="(currentSku?.discountBadge as unknown as IBadge) || undefined"
          :availableAmount="currentSku?.availableAmount || 0"
        />
      </MMContainer>
    </div>
  </transition>
</template>

<style lang="stylus" scoped>
.floating-cap
  height 96px
  background-color #FFFFFF
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.02), 0px 4px 20px rgba(0, 0, 0, 0.05);
  position fixed
  left 0
  right 0
  top 0
  z-index 100

  .floating-cap-wrapper
    display flex
    justify-content space-between
    align-items center
    height 100%

    .product-header-wrapper
      display flex
      align-items center

      .image
        margin-right 16px
        width 60px
        height 80px
        border-radius 8px

    .price-block
      display flex
      justify-content flex-end
      gap 12px
      width 620px

// floating-cap transition
.slide-leave-active,
.slide-enter-active
  transition transform 0.45s cubic-bezier(0.65, 0, 0.35, 1)

.slide-enter
  transform translateY(-100%)
.slide-enter-to
  transform translateY(0)

.slide-leave
  transform translateY(0)
.slide-leave-to
  transform translateY(-100%)
</style>
